import {useEffect} from "react";
import {locationService, LocationType} from "@/entities/location";

export const useLocationInitialization = (location: LocationType) => {
    useEffect(() => {
        locationService.initialize(location);
    }, []);

    useEffect(() => {
        const timeout = setTimeout(async () => {
            await locationService.detect();
        }, 1000);

        return () => clearTimeout(timeout);
    }, []);
}
